import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';


import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';

import { isEmpty } from 'lodash';
import { UnidataTable } from '~/components';

import { recordFiltering } from '~/store/modules/postoPlanejamentoGpp/actions'
import { Container } from './styles';
import * as S from './styles';

export default function DadosGPP({ dataPosto }) {
  const [usuariosGPP, setUsuariosGPP] = useState([]);

  const data = useSelector(state => state.postoPlanejamentoGpp)

  const [query, setQuery] = useState({
    fieldlist:
      'usua_login, usua_nome, usua_cpf, usua_email, usua_recebe_email_str, usua_status_str',
    wherefield: ['perf_codigo', 'poco_codigo'],
    typewherefield: ['EQUALS', 'EQUALS'],
    valuewherefield: ['6', dataPosto.poco_codigo],
    orderfield: 'usua_login',
    pagesize: 99999,
  })

  const header = useMemo(() => [
    {
      id: 'usua_login',
      label: 'Login',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'usua_nome',
      label: 'Nome',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'usua_cpf',
      label: 'CPF',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'usua_email',
      label: 'E-mail',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'usua_recebe_email_str',
      label: 'Recebe E-mail',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'usua_status_str',
      label: 'Status',
      filter: {
        type: 'text',
      },
    },
  ], []);



  return (
    <>
      <S.Wrapper style={{ width: '100%', height: '500px', overflowX: 'scroll' }}>
        <S.ConteinerTab >
          <ExpansionPanel expanded>
            <ExpansionPanelSummary
              aria-controls="panel1a-content"
              id="panel1a-header"
              style={{
                background: 'rgba(0, 0, 0, 0.05)',
                borderBottom: '1px solid rgba(0,0,0,.2)',
              }}
            >
              <Typography>Usuários GP</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Container style={{ width: '100%' }}>
                <UnidataTable
                  dense
                  update={false}
                  create={false}
                  delete={false}
                  header={header}
                  redux={data}
                  query={query}
                  keys="usua_login"
                  detach="usua_nome"
                  read={recordFiltering}
                  maxHeight={'100%'}
                />
              </Container>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </S.ConteinerTab>
      </S.Wrapper>
    </>
  );
}
